<template>
    <div>
        <el-row type="flex" class="row-bg p-10 mt-10 bg-lightgarg" justify="space-between">
            <el-col :span="5">
                <div class="grid-content">
                    <el-select v-model="selecttripvalue" no-match-text="No data" no-data-text="No data" filterable clearable placeholder="Trip" @change="" style="width: 100%">
                        <el-option v-for="item in options" :label="item.name" :key="item.id" :value="item.id"></el-option>
                    </el-select>
                </div>
            </el-col>
        </el-row>

        <!--穿梭框-->
        <transfer-box :selecttripvalue="selecttripvalue"></transfer-box>
    </div>
</template>

<script>
    import Cookies from 'js-cookie'
    import TransferBox from '../common/TransferBox.vue'
    //import ElRow from "../../../node_modules/element-ui/packages/row/src/row";
    export default {
        //components: {ElRow},
        components: {
            "transfer-box": TransferBox
        },
        data() {
            return {
                //获取trip列表
                selecttripvalue: '',
                options: []
            }
        },
        mounted: function () {
            this.$nextTick(function () {
                this.getTrip();
            })
        },
        methods: {
            //获取trip列表
            getTrip(){
                this.$http.get('trip/list').then(response => {
                    this.options = response;
                }).catch(error => {
                    this.$message.error(error.message)
                })
            },
        }
    }
</script>

<style lang="scss" scope>
    .actions{
        padding-top: 293px;
        text-align: center;
    }
</style>


// WEBPACK FOOTER //
// TeacherRelation.vue?87adcc3e